export const DEFAULT_BRAND_SLUG = "any-brand";
export const SHOP_BY_BRAND_PATH = "/shop-brand";
export const SHOP_ALL_PRODUCTS_PATH = "/shop-category";

export const isDefaultBrandSlug = (value) =>
  String(value || "").trim().toLowerCase() === DEFAULT_BRAND_SLUG;

export const resolveBrandPath = (brandSlug) => {
  if (isDefaultBrandSlug(brandSlug)) {
    return SHOP_BY_BRAND_PATH;
  }

  const normalizedBrandSlug = String(brandSlug || "").trim();
  if (!normalizedBrandSlug) {
    return SHOP_BY_BRAND_PATH;
  }

  return `/shop-brand/${encodeURIComponent(normalizedBrandSlug)}`;
};
